import { parseAsInteger, useQueryStates } from 'nuqs';

export function useQuestionCreationItemSetSearchParam() {
  const [{ size }, setQuestionCreationItemSetSearchParam] = useQueryStates({
    size: parseAsInteger,
  });

  const changeSize = (size: number) => {
    setQuestionCreationItemSetSearchParam({ size });
  };

  return [{ size }, { changeSize }] as const;
}
